/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-11-10 10:39:00
 */

 import {Component,Prop} from 'vue-property-decorator'
 import ErrorFileService from "./errorFileService";
 import BasicSearchPage from "../../../../components/basicSearchPage/basicSearchPage";
 import override from "../../../../dectorators/override";
 import {TestDOI} from '../api/testApi';
 import QueryForm from 'src/components/queryForm/queryForm';
 

@Component
export default class ErrorFile extends BasicSearchPage<ErrorFileService, TestDOI.ErrorNoDetails, TestDOI.QueryRowDataParamsIDetail> {
    @Prop({
        type: Number
    })
    id: number

    checkBoxShow = false
    className='wqms-pt0'
    @override
    renderHead(h) {
        return <div></div>
    }
    @override
    renderQuery(h) {
		return <div style="width:100%">
            <QueryForm style="display: inline-block;vertical-align: middle;" ref="queryForm" showClear={false} dataSource={this.queryFormData} on-search={this.search}/>
        </div>
	}
    
	@override
    loadService () {
        this.service = new ErrorFileService(this)
    }
}





 